import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconParkingComponent } from "./med-icon-parking.component";

@NgModule({
  declarations: [
    MedIconParkingComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconParkingComponent,
  ],
})
export class MedIconParkingModule { }
